import { React, useState, useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import Softwareaccess from '../SoftwareAccess';
import Vpnaccess from '../VPNRequest';
import Sharepoint from '../SharepointAccess';	
import Vendormaster from '../AccessreqVendor';	
import fileDownload from 'js-file-download';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';								
import { CREATE_PPR,UPDATEPPRDATA,GET_SAVEDUSBREQUEST,PPRFILES,GET_SAVEDPPR,GETPPRFILE} from '../AppConstant'
function Landing() {
    const [claimno, setClaimno] = useState("");
    const [claimdate, setClaimdate] = useState("");
    const [dealername, setDealername] = useState("");
    const [location, setLocation] = useState("");
    const [statedata, setStatedata] = useState("");
    const [pprno, setPprno] = useState("");
    const [pprissue, setPprissue] = useState("");
    const [failurdate, setFailurdate] = useState("");
    const [vin, setVin] = useState("");
    const [dos, setDos] = useState("");
    const [partdetails, setPartdetails] = useState("");
    const [tcsmremarks, SetTcsmremarks] = useState("");
    const [tcsm, setTcsm] = useState("");
    const [reportedmonth, setReportedmonth] = useState("");
    const [monthdata, setMonthdata] = useState("");
    const [model, setModel] = useState("");
    const [warrenty, setWarrenty] = useState("");
    const [dealer, setDealer] = useState("");
    const [pprreceived, setPprreceived] = useState("");
    const [pprraise, setPprraise] = useState("");
    const [issueno,setIssueno]= useState("");
    const [km,setKm]= useState("");
    const [requestorname, setRequestorname] = useState("");     
    const [isfirsttab,setIsfirsttab]= useState(true);
    const [issecondtab,setIssecondtab]= useState(false);
    const [pprlist,setPprlist] = useState([]);
    const [mindateset,setMindateset]= useState("");
    const [excelfile,setExcelfile]= useState("");
    const [searchdata, setSearchdata] = useState([]);
     const [savedraw, setSavedraw] = useState([]);
     const [savedlist, setSavedlist] = useState([]);
     const [createuri,setCreateuri]= useState("");
    const [opensuccess,setOpensuccess]= useState(true);
    const [statusvalue,setStatusvalue]= useState("");
    const [open,setOpen]= useState(false);
     const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [remarksdata,setRemarksdata]= useState("");
    const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
    const calltosetmindate = () => {
        let month;
        let day;
        if ((new Date().getMonth() + 1) < 10) {
            month = "0" + (new Date().getMonth() + 1)
        } else {
            month = (new Date().getMonth() + 1)
        }
        if (new Date().getDate() < 10) {
            day = "0" + new Date().getDate()
        } else {
            day = new Date().getDate()
        }
        let date = new Date().getFullYear() + '-' + month + '-' + day;
        setMindateset(date);
    }

    useEffect(() => {
        calltosetmindate();
        getsession();
    }, []);

    const getsession=()=>{
        if(localStorage.getItem('sessions')!=="isactive"){
            window.location.href = "/"
        }       
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!claimno || !claimdate || !dealername || !location || !statedata || !pprno || !pprissue || !failurdate || !vin || !dos || !partdetails || !tcsmremarks || !tcsm || !reportedmonth || !monthdata || !model || !warrenty || !dealer || !pprreceived || !pprraise || !km|| !issueno ) {
            alert("Please fill all the fields")
        } else {
          getUserData();

        }

        // Add your form submission logic here

    };

    const redirectToLogin = () => {
        window.location.href = "/login"
    }

     const searchfunction = (value) => {
    setSearchdata(value);
    if (value !== "") {
      let e = value.toLowerCase();
      let newarray = savedraw.filter(function (val) {
        if (
          val.claimno.toLowerCase().includes(e) ||
          val.dealername.toLowerCase().includes(e) ||
          val.location.toLowerCase().includes(e) ||
          val.statedata.toLowerCase().includes(e) ||
          val.pprno.toLowerCase().includes(e) ||
          val.pprissue.toLowerCase().includes(e) ||
          val.vin.toLowerCase().includes(e) ||
          val.model.toLowerCase().includes(e)
        ) {
          var newobjs = {
            id: val.claimno,
            dealer: val.dealername,
            location: val.location,
          };
          return newobjs;
        }
      });
      setPprlist(newarray);
    } else {
      setPprlist(savedraw);
    }
  };
  const updatepprdata=()=>{
      let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let empemailid = localStorage.getItem('emailid');
        let updated_by = localStorage.getItem('empname');

         axios.post(UPDATEPPRDATA, { statedata, updated_by,statusvalue,remarksdata })
            .then(function (response) {
                //console.log("SuccessFully updated");
                alert(response.data);
                callsaveddata();
                setOpen(false)
                // handleReset();


            })
            .catch(function (error) {
                console.log(error);
            });

  }
    const getUserData = () => {

        let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let empemailid = localStorage.getItem('emailid');
        let empname = localStorage.getItem('empname');
        



        axios.post(CREATE_PPR, { empid, empemailid,empname,rqdept,claimno,claimdate,dealername,location,statedata,pprno,pprissue,failurdate,vin,dos,partdetails,tcsmremarks,tcsm,reportedmonth,monthdata,model,warrenty,dealer,pprreceived,pprraise,issueno,km })
            .then(function (response) {
                //console.log("SuccessFully updated");
                alert(response.data);
                calluploadexcell();
                // handleReset();


            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const calluploadexcell=(e)=>{
         axios({     method: 'post',
                    url: PPRFILES,
                    headers: { "Content-Type": "multipart/form-data" },
                    data : excelfile
        
                }).then(response => {
                    // alert(response.data);
                    
                })  
                .catch(error => {
                    console.error(error);
                });
    }
    const redirectTodashboard = () => {
        window.location.href = "/landingPage"
    }

    // const checkedval = (e) => {
    //     if (e.currentTarget.checked === true) {
    //         setIfchecked(true)
    //     } else {
    //         setIfchecked(false)
    //     }

    // }
    // const callselectedfn = (e) => {
    //     setSelectedrpmanager(e.target.value)
    //     setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    // }
    const callinputsetfn = (e) => {
        if (e.target.value.length > 6) {
            alert("Employee ID cannot exceed 6 digit")

        } else {
            setRequestorname(e.target.value)
        }

    }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn = (e) => {
        let checkvalue = e.target.value
        if (e.target.value.length === 12) {
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if (result1 || result2 === true) {
                alert("Should contain alphanumeric")
            }

        }
        // setAsset_id(e.target.value)
    }
	// const callselectrequest=(e)=>{
    //     setSelectaccessrequest(e.target.value)
    // }
    const enabletab=(e)=>{
        if(e===2){
            setIsfirsttab(false)
            setIssecondtab(true)
            callsaveddata()
        }else{
           
            setIsfirsttab(true)
            setIssecondtab(false)
        }
       }
    const callsaveddata=()=>{
                   axios({
                       method: "get",
                       url: GET_SAVEDPPR,
                       withCredentials: false,
                       headers: {
                         "Content-Type": "application/x-www-form-urlencoded",
                         "Access-Control-Allow-Origin": "*",
                       },
                       params:{"emp_id" : localStorage.getItem('empid')}
                     })
                       .then((response) => {
                           // setsavedvendorraw(response.data.data)
                            setSavedraw(response.data.data);
                            setSavedlist(response.data.data);
                           setPprlist(response.data.data);
                       })
                       .catch((error) => {
                         console.error(error);
                       });
               }
               
    const filechangeofferfn=(file,d)=>{
    console.log(file)
    // setRawdatafile(file)
    if(file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type ==="application/vnd.ms-excel.sheet.macroEnabled.12"){
        if(file.size <= 5000000){
            const formData = new FormData();
        let d=file.name
        let c = d.split('.')       
        formData.append('type', "PPR");
        formData.append('ID', claimno);
        formData.append('file',file);
        formData.append('filename',c[0]);
        console.log(formData)
        setExcelfile(formData)
        
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only Excel format")
    }
   }

    const calldownload = (e) => {
       
       axios({
         method: "post",
         url: GETPPRFILE,
         headers: { "Content-Type": "application/x-www-form-urlencoded" },
         data: { claimno: e.claimno },
         responseType: "blob",
       })
         .then((response) => {
           const urlss = URL.createObjectURL(response.data);
           console.log(urlss);
           setCreateuri(urlss);
           var d = response.headers['content-type'].split(".")
            fileDownload(response.data,d[0]+ "_PPR_"+new Date()+ "." +d[1]);
            // downloadfiles(e.claimno,urlss)
           // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        //    if (response.data.size === 14) {
        //      alert("No Data Available");
        //      setIsloading(false);
        //    } else {
        //      console.log(response.data);
        //      var reader = new FileReader();
        //      reader.readAsDataURL(response.data);
        //      reader.onloadend = function () {
        //        var base64data = reader.result;
        //        console.log(base64data);
        //        setViewpdfdcsaadnar(base64data);
        //        let data_split = base64data.split(",");
        //        let dataset =
        //          "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
        //        setViewpdfdcsaadnar(dataset);
        //        setOpenpdfadhara(true);
        //        setIsloading(false);
        //      };
        //    }
         })
         .catch((error) => {
           console.error(error);
         });
     };

     const downloadfiles = (ee,es) => {
    const hrefee = es;
    const link = document.createElement("a");
    link.href = hrefee;
    link.setAttribute("ppr",  ee + "_PPR.xlsx"); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
  };
  const handleReset=()=>{{
        setClaimno("");
   setClaimdate("");
    setDealername("");
    setLocation("");
  setStatedata("");
    setPprno("");
   setPprissue("");
   setFailurdate("");
  setVin("");
   setDos("");
    setPartdetails("");
     SetTcsmremarks("");
  setTcsm("");
    setReportedmonth("");
    setMonthdata("");
   setModel("");
    setWarrenty("");
   setDealer("");
     setPprreceived("");
        setPprraise("");
  }}
   const callclosesuccess=()=>{
        setOpensuccess(false)
     }
     const handleChangerecoment = (e) => {
    setStatusvalue(e.target.value);
  };
  const openmodeldata=(e)=>{
    setOpen(true)
    setStatedata(e.claimno)
  }
    return (
         <div className="bg_set_usb">   
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
             <div>
            </div>
            <div>
        <div className="Apps_ppr">
            <p className="Headings">PPR Request</p>
             {opensuccess===true?<Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
     PPR 
    </Typography>
      
        <label for="state">Claim No</label>
        <input
                        type="text"
                        name="state"
                        id="state"
                        value={statedata}
                        disabled
                        placeholder="Claim No"
                        
                       
                    />
                    <label for="state">Status</label> 
	 <select
                            name="select"
                            id="selected"
                            onChange={(e) => handleChangerecoment(e)}
                            defaultValue=""
                            value={statusvalue}
                            // onChange={(e) =>callselectrequest(e)}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Accept">Accept</option>
                            <option value="Reject">Reject</option>
                            
                          </select>	
<label for="state">Remarks</label>
                    <input
                        type="text"
                        name="state"
                        id="state"
                        value={remarksdata}
                        onChange={(e) =>
                            setRemarksdata(e.target.value)                          
                        }
                        
                        placeholder="Remarks"
                        required
                       
                    />
                    <div className="row " >
                    <div className="col-md-8">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => updatepprdata(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>						  
  </Box>
</Modal>:''}  
           {issecondtab? <div>
            <div className="col-md-1">
                    <label htmlFor="switchcode">Search</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="switchcode"
                      id="switchcode"
                      value={searchdata}
                      onChange={(e) => searchfunction(e.target.value)}
                      placeholder="Search"
                      required
                    />
                  </div>
                  </div>:''}
            <fieldset>
				 
                <div className="row ">
                        <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Creation</div>  
                        <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>View </div> 
                    </div>
               {isfirsttab?<div><form action="#" method="get">
               
                    <div className="row">
                         
                    <div className="col-md-4">
                    <label for="claimno">
                    Claim No
                    </label>
                    <input
                        type="text"
                        name="claimno"
                        id="claimno"
                        value={claimno}
                        onChange={(e) =>
                            setClaimno(e.target.value)
                        }
                        placeholder="Claim No."
                        required
                    />
                    </div>
                    <div className="col-md-4"> <label for="claimdate">Claim Date</label>
                    <input type="date"  onChange={(e) =>setClaimdate(e.target.value)} id="claimdate" name="claimdate"/>
                    </div>
                   
                    <div className="col-md-4">
                    <label for="dealername">Dealer Name</label>
                    <input
                        type="text"
                        name="dealername"
                        id="dealername"
                        value={dealername}
                        onChange={(e) =>
                            setDealername(e.target.value)                        
                        }
                        
                        placeholder="dealername"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="location">Location</label>
                    <input
                        type="text"
                        name="location"
                        id="location"
                        value={location}
                        onChange={(e) =>
                            setLocation(e.target.value)                          
                        }
                        
                        placeholder="location"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="state">State</label>
                    <input
                        type="text"
                        name="state"
                        id="state"
                        value={statedata}
                        onChange={(e) =>
                            setStatedata(e.target.value)                          
                        }
                        
                        placeholder="State"
                        required
                       
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="PPRNo">PPR NO.</label>
                    <input
                        type="text"
                        name="PPRNo"
                        id="PPRNo"
                        value={pprno}
                        onChange={(e) =>
                            setPprno(e.target.value)                          
                        }
                        
                        placeholder="PPR No."
                        required
                         
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="PPRissue">PPR Issue</label>
                    <input
                        type="text"
                        name="PPRissue"
                        id="PPRissue"
                        value={pprissue}
                        onChange={(e) =>
                            setPprissue(e.target.value)                          
                        }
                        
                        placeholder="PPRissue"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="KM">Km</label>
                    <input
                        type="text"
                        name="KM"
                        id="KM"
                        value={km}
                        onChange={(e) =>
                            setKm(e.target.value)                          
                        }
                        
                        placeholder="KM"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="failure_date">FAILURE DATE</label>
                   <input type="date"  onChange={(e) =>setFailurdate(e.target.value)} id="failuredate" name="failuredate"/>
                    </div>
                     <div className="col-md-4">
                    <label for="vin">VIN NO.</label>
                    <input
                        type="text"
                        name="vin"
                        id="vin"
                        value={vin}
                        onChange={(e) =>
                           setVin(e.target.value)                          
                        }
                        
                        placeholder="VIN NO."
                        required
                         
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="date_of_sale">Date of Sale</label>
                   <input type="date"   onChange={(e) =>setDos(e.target.value)} id="date_of_sale" name="date_of_sale"/>
                    </div>
                    <div className="col-md-4">
                    <label for="partdetails">PART DETAILS</label>
                    <input
                        type="text"
                        name="partdetails"
                        id="partdetails"
                        value={partdetails}
                        onChange={(e) =>
                            setPartdetails(e.target.value)                          
                        }
                        
                        placeholder="Part Details"
                        required
                         
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="TCSM">TCSM</label>
                    <input
                        type="text"
                        name="tcsm"
                        id="tcsm"
                        value={tcsm}
                        onChange={(e) =>
                            setTcsm(e.target.value)                          
                        }
                        
                        placeholder="TCSM"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="TCSMRemarks">TCSM Sharp Remarks</label>
                    <input
                        type="text"
                        name="TCSMRemarks"
                        id="TCSMRemarks"
                        value={tcsmremarks}
                        onChange={(e) =>
                            SetTcsmremarks(e.target.value)                          
                        }
                        
                        placeholder="TCSM Sharp Remarks"
                        required
                        
                    />
                    </div> 
                    <div className="col-md-4">
                    <label for="month">Month</label>
                    <input
                        type="text"
                        name="month"
                        id="month"
                        value={monthdata}
                        onChange={(e) =>
                            setMonthdata(e.target.value)                          
                        }
                        
                        placeholder="Month"
                        required
                         
                    />
                    </div> 
                    <div className="col-md-4">
                    <label for="reportedmonth">REPORTED MONTH</label>
                    <input
                        type="text"
                        name="reportedmonth"
                        id="reportedmonth"
                        value={reportedmonth}
                        onChange={(e) =>
                            setReportedmonth(e.target.value)                          
                        }
                        
                        placeholder="REPORTED MONTH"
                        required
                        
                    />
                    </div> 
                    <div className="col-md-4">
                    <label for="Within">Within Warranty</label>
                    <input
                        type="text"
                        name="Within"
                        id="Within"
                        value={warrenty}
                        onChange={(e) =>
                            setWarrenty(e.target.value)                          
                        }
                        
                        placeholder="Within Warranty"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="model">MODEL</label>
                    <input
                        type="text"
                        name="model"
                        id="model"
                        value={model}
                        onChange={(e) =>
                            setModel(e.target.value)                          
                        }
                        
                        placeholder="MODEL"
                        required
                         
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="dealer">Dealer</label>
                    <input
                        type="text"
                        name="dealer"
                        id="dealer"
                        value={dealer}
                        onChange={(e) =>
                            setDealer(e.target.value)                          
                        }
                        
                        placeholder="Dealer"
                        required
                       
                    />
                    </div>  
                    <div className="col-md-4">
                    <label for="pprreceived">PPR Received from Field</label>
                    <input
                        type="text"
                        name="pprreceived"
                        id="pprreceived"
                        value={pprreceived}
                        onChange={(e) =>
                            setPprreceived(e.target.value)                          
                        }
                        
                        placeholder="PPR Received from Field"
                        required
                         
                    />
                    </div> 
                    <div className="col-md-4">
                    <label for="ppr_raise">PPR RAISED to FQ </label>
                    <input
                        type="text"
                        name="ppr_raise"
                        id="ppr_raise"
                        value={pprraise}
                        onChange={(e) =>
                            setPprraise(e.target.value)                          
                        }
                        
                        placeholder="PPR RAISED to FQ"
                        required
                        
                    />
                    </div> 
                    <div className="col-md-4">
                    <label for="issueno">Issue No</label>
                    <input
                        type="text"
                        name="issueno"
                        id="issueno"
                        value={issueno}
                        onChange={(e) =>
                            setIssueno(e.target.value)                          
                        }
                        
                        placeholder="Issue No"
                        required
                        
                    />
                    </div> 

                   
                       
                        <div className="col-md-4"><label for="myfile">Upload</label>
                        <input type="file" id="myfile_offer"  accept="application/excel" onChange={(event) => filechangeofferfn(event.target.files[0] || null,"myfile_offer")} name="myfile" />
                        </div>
                        
                        
                      
                            
                    
                    </div>
                   
                    <div className="row">
                    <div className="col-md-6">
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="col-md-6">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>
                </form></div>: <table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Claim No</th>
                  <th>Claim Date</th>
                  <th>Status</th>
                  <th>Updated BY</th>
                  <th>Updated ON</th>
                   <th>remarks</th>                  
                  <th>Dealer Name</th> 
                  <th>Created on</th> 
                  <th>Location</th> 
                  <th>State</th> 
                  <th>PPR NO.</th> 
                  <th>PPR Issue</th> 
                  <th>Km</th> 
                  <th>FAILURE DATE</th> 
                  <th>VIN NO.</th> 
                  <th>Date of Sale</th> 
                  <th>PART DETAILS</th> 
                  <th>TCSM</th> 
                  <th>TCSM Sharp Remarks</th> 
                  <th>Month</th> 
                  <th>REPORTED MONTH</th> 
                  <th>Within Warranty</th> 

                  <th>MODEL</th>
                  {/* <th>DOJ</th> */}
                  <th>Dealer</th>
                   <th>PPR Received from Field</th>
                    <th>PPR RAISED to FQ </th>
                     <th>Issue No</th>
                     <th>Action</th>
                      <th>Download</th>

                  {/* <th>Vendor Name</th> */}
                  {/* <th>Sub Department</th> */}
                  {/* <th>Remarks</th>
                  {/* <th>Manager Employee ID</th> */}
                  {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                  {/* <th>Verified</th>
                  <th>Status</th>
                  <th>Remarks</th> */}
                  
                </tr>
              </thead>
              <tbody>
              {pprlist.length?pprlist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.claimno}</td>
                          <td>{val.claimdate}</td>
                           <td>{val.status}</td>
                          <td>{val.updated_by}</td>
                          <td>{val.updated_on}</td>
                          <td>{val.remarksdata}</td>
                          <td>{val.dealername}</td>
                          {/* <td>{val.doj}</td>  */}                          
                          <td>{val.created_timestamp}</td>
                          <td>{val.location}</td>
                          <td>{val.statedata}</td>  
                          <td>{val.pprno}</td>  
                          <td>{val.pprissue}</td> 
                            <td>{val.km}</td>  
                          <td>{val.failurdate}</td>  
                          <td>{val.vin}</td>  
                          <td>{val.dos}</td>  
                          <td>{val.partdetails}</td> 
                           <td>{val.tcsm}</td>   
                          <td>{val.tcsmremarks}</td>  
                         
                          <td>{val.reportedmonth}</td>  
                          <td>{val.monthdata}</td> 
                           <td>{val.model}</td>
                            <td>{val.warrenty}</td>
                             <td>{val.dealer}</td>
                              <td>{val.pprreceived}</td> 
                              <td>{val.pprraise}</td> 
                              
                                <td>{val.issueno}</td> 
                                <td><i className="bi bi-pencil-square" title="Edit Image" onClick={() => openmodeldata(val)} style={{ color: "blue", cursor: "pointer" }} /></td>
                                <td onClick={(e)=>calldownload(val)}>{"Click to Download"}</td> 
                                                   
                          {/* <td>{val.sub_department}</td>  */}
                          
                          {/* <td>{val.manager_id}</td>  */}
                          {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  
                          <td>{val.verified}</td>
                          <td>{val.status} </td> 
                          <td>{val.remarks}</td>*/}
                            {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                          {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                          
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table>}         
                
            </fieldset>
        </div> 
            </div>
        
        </div>
    );
}


export default Landing;
